const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.HorseExamServiceSimpleClient =
  function HorseExamServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.getHorseExam = this.getHorseExam.bind(this);
    this.listHorseExams = this.listHorseExams.bind(this);
    this.createHorseExam = this.createHorseExam.bind(this);
    this.editHorseExam = this.editHorseExam.bind(this);
    this.deleteHorseExam = this.deleteHorseExam.bind(this);
    this.cancelHorseExam = this.cancelHorseExam.bind(this);
    this.completeHorseExam = this.completeHorseExam.bind(this);
    this.pullHorseExamConditions = this.pullHorseExamConditions.bind(this);
    this.getHorseExamComment = this.getHorseExamComment.bind(this);
    this.listHorseExamComment = this.listHorseExamComment.bind(this);
    this.pullHorseExamReport = this.pullHorseExamReport.bind(this);
  };
const methodInfo_HorseExamService_GetHorseExam = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseExamService/GetHorseExam",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.GetHorseExamRequest,
  imports.stronachgroup.first.racehorse360.HorseExam,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.HorseExam.decode
);
module.exports.HorseExamServiceSimpleClient.prototype.getHorseExam = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.GetHorseExamRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.HorseExamService/GetHorseExam",
    message,
    metadata || {},
    methodInfo_HorseExamService_GetHorseExam
  );
};
const methodInfo_HorseExamService_ListHorseExams =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/ListHorseExams",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListHorseExamsRequest,
    imports.stronachgroup.first.racehorse360.ListHorseExamsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListHorseExamsResponse.decode
  );
module.exports.HorseExamServiceSimpleClient.prototype.listHorseExams =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListHorseExamsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/ListHorseExams",
      message,
      metadata || {},
      methodInfo_HorseExamService_ListHorseExams
    );
  };
const methodInfo_HorseExamService_CreateHorseExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/CreateHorseExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateHorseExamRequest,
    imports.stronachgroup.first.racehorse360.HorseExam,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.HorseExam.decode
  );
module.exports.HorseExamServiceSimpleClient.prototype.createHorseExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateHorseExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/CreateHorseExam",
      message,
      metadata || {},
      methodInfo_HorseExamService_CreateHorseExam
    );
  };
const methodInfo_HorseExamService_EditHorseExam = new grpc.web.MethodDescriptor(
  "/stronachgroup.first.racehorse360.HorseExamService/EditHorseExam",
  grpc.web.MethodType.UNARY,
  imports.stronachgroup.first.racehorse360.EditHorseExamRequest,
  imports.stronachgroup.first.racehorse360.HorseExam,
  function (message) {
    return message.constructor.encode(message).finish();
  },
  imports.stronachgroup.first.racehorse360.HorseExam.decode
);
module.exports.HorseExamServiceSimpleClient.prototype.editHorseExam = function (
  request,
  metadata
) {
  const message =
    imports.stronachgroup.first.racehorse360.EditHorseExamRequest.create(
      request
    );
  return this.client_.unaryCall(
    this.hostname_ +
      "/stronachgroup.first.racehorse360.HorseExamService/EditHorseExam",
    message,
    metadata || {},
    methodInfo_HorseExamService_EditHorseExam
  );
};
const methodInfo_HorseExamService_DeleteHorseExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/DeleteHorseExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteHorseExamRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.HorseExamServiceSimpleClient.prototype.deleteHorseExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteHorseExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/DeleteHorseExam",
      message,
      metadata || {},
      methodInfo_HorseExamService_DeleteHorseExam
    );
  };
const methodInfo_HorseExamService_CancelHorseExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/CancelHorseExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CancelHorseExamRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.HorseExamServiceSimpleClient.prototype.cancelHorseExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CancelHorseExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/CancelHorseExam",
      message,
      metadata || {},
      methodInfo_HorseExamService_CancelHorseExam
    );
  };
const methodInfo_HorseExamService_CompleteHorseExam =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/CompleteHorseExam",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CompleteHorseExamRequest,
    imports.stronachgroup.first.racehorse360.HorseExam,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.HorseExam.decode
  );
module.exports.HorseExamServiceSimpleClient.prototype.completeHorseExam =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CompleteHorseExamRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/CompleteHorseExam",
      message,
      metadata || {},
      methodInfo_HorseExamService_CompleteHorseExam
    );
  };
const methodInfo_HorseExamService_PullHorseExamConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/PullHorseExamConditions",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullHorseExamConditionsRequest,
    imports.stronachgroup.first.racehorse360.PullHorseExamConditionsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullHorseExamConditionsResponse.decode
  );
module.exports.HorseExamServiceSimpleClient.prototype.pullHorseExamConditions =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullHorseExamConditionsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/PullHorseExamConditions",
      message,
      metadata || {},
      methodInfo_HorseExamService_PullHorseExamConditions
    );
  };
const methodInfo_HorseExamService_GetHorseExamComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/GetHorseExamComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetHorseExamCommentRequest,
    imports.stronachgroup.first.racehorse360.HorseExamComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.HorseExamComment.decode
  );
module.exports.HorseExamServiceSimpleClient.prototype.getHorseExamComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetHorseExamCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/GetHorseExamComment",
      message,
      metadata || {},
      methodInfo_HorseExamService_GetHorseExamComment
    );
  };
const methodInfo_HorseExamService_ListHorseExamComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/ListHorseExamComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListHorseExamCommentsRequest,
    imports.stronachgroup.first.racehorse360.ListHorseExamCommentsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListHorseExamCommentsResponse.decode
  );
module.exports.HorseExamServiceSimpleClient.prototype.listHorseExamComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListHorseExamCommentsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/ListHorseExamComment",
      message,
      metadata || {},
      methodInfo_HorseExamService_ListHorseExamComment
    );
  };
const methodInfo_HorseExamService_PullHorseExamReport =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.HorseExamService/PullHorseExamReport",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullHorseExamReportRequest,
    imports.stronachgroup.first.racehorse360.PullHorseExamReportResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullHorseExamReportResponse.decode
  );
module.exports.HorseExamServiceSimpleClient.prototype.pullHorseExamReport =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullHorseExamReportRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.HorseExamService/PullHorseExamReport",
      message,
      metadata || {},
      methodInfo_HorseExamService_PullHorseExamReport
    );
  };
